export enum RedactCommentModalType {
  Manual = "Manual",
  Request = "Request",
}
